import { FC, useMemo } from 'react';

import { GenInternalLink } from '@/components/generics';

import useLocale from '@/hooks/useLocale';

import { DisplayDateFormat } from '@/utils/dates/constants';
import { formatDateForDisplay } from '@/utils/dates/dateFormatters';

import { CTA_NAMES } from '@/utils/rudderstack';

import { trackClickEvent } from '../../../../../utils';

export interface ShipDateProps {
  shipDateText: string;
  editText: string;
  scheduledDate: string;
  canEdit: boolean;
}

const ShipDate: FC<ShipDateProps> = ({
  shipDateText,
  editText,
  scheduledDate,
  canEdit,
}) => {
  const locale = useLocale();

  const shippingDate = useMemo(
    () =>
      scheduledDate
        ? formatDateForDisplay(
            scheduledDate,
            locale,
            DisplayDateFormat.ShortMonthDayYear,
          )
        : null,
    [scheduledDate, locale],
  );

  if (!shippingDate) {
    return null;
  }

  return (
    <div
      className="flex flex-row gap-x-2 md:gap-x-4 items-end"
      data-testid="shipDate"
    >
      <p className="text-sm md:text-base flex flex-row gap-2">
        <span className="font-bold">{shipDateText}</span>
        <span>{shippingDate}</span>
      </p>

      {canEdit && (
        <GenInternalLink
          classes="text-sm md:text-base"
          // @todo: add the correct href
          href="###NEW_EDIT_SHIP_DATE_PAGE###"
          cta={editText}
          onClick={() => {
            trackClickEvent(CTA_NAMES.EDIT_SHIP_DATE);
          }}
        />
      )}
    </div>
  );
};

export default ShipDate;
